module.exports = __webpack_public_path__ + "static/media/jamonQueso.3b33648d.jpg";